module.exports = __webpack_public_path__ + "img/空白（同页宽）.5c35281d.jpg";